import React from "react";
import HiringCheckListTableData from "./HiringCheckListTableData";
import { TableHeader } from "../../../commons";
import {
  HIRING_CHECKLIST_HEADERS,
  STICKY_HIRING_CHECKLIST_HEADERS,
} from "../../../../constant/hrms/recruitmentModule/recruiterModuleConst";
import StickyHiringTableData from "./StickyHiringTableData";
type AppProps = {
  history: any;
  data: any;
  type?: string;
  handleEditHiringCheckList?: (data: any) => void;
};
const HiringCheckListTable = ({
  history,
  data,
  type,
  handleEditHiringCheckList,
}: AppProps) => {
  return (
    <>
      <div className="d-flex">
        <div className="hiring">
          <table className="table thead-light table-bordered">
            <thead className="text-start">
              <tr>
                <th style={{ height: "75px",
                // display:"flex",alignItems:"start" 
                }}>Candidate Name</th>
              </tr>
            </thead>
            <tbody>
              <StickyHiringTableData
                data={data}
                header={STICKY_HIRING_CHECKLIST_HEADERS}
                handleEditHiringCheckList={handleEditHiringCheckList}
              />
            </tbody>
          </table>
        </div>
        <div className="hiring" style={{ overflowX: "scroll" }}>
          <table className="table thead-light table-bordered">
            <thead className="sticky-table-header">
              <TableHeader tableHeader={HIRING_CHECKLIST_HEADERS} />
            </thead>
            <tbody>
              <HiringCheckListTableData
                data={data}
                header={HIRING_CHECKLIST_HEADERS}
                history={history}
              />
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default HiringCheckListTable;
